export default {
  page_title: 'SolvV',
  hello: 'Hallo!',
};
